import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  PawPrint,
  Handshake,
  Settings,
} from "lucide-react";
import "../../styles/admin/admin-sidebar.css";

export default function AdminSidebar() {
  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-top">
        <div className="admin-logo-mark">🐾</div>
        <div className="admin-brand-text">
          <h2>Petfam Admin</h2>
          <p>Gestión general</p>
        </div>
      </div>

      <nav className="admin-sidebar-nav">
        <NavLink to="/admin" end className="admin-link">
          <LayoutDashboard size={18} />
          <span>Dashboard</span>
        </NavLink>

        <NavLink to="/admin/usuarios" className="admin-link">
          <Users size={18} />
          <span>Usuarios</span>
        </NavLink>

        <NavLink to="/admin/mascotas" className="admin-link">
          <PawPrint size={18} />
          <span>Mascotas</span>
        </NavLink>

        <NavLink to="/admin/aliados" className="admin-link">
          <Handshake size={18} />
          <span>Aliados</span>
        </NavLink>
      </nav>
    </aside>
  );
}